import React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import ProductNav from '@redbubble/design-system/react/ProductNav';
import { withAnalytics } from '@redbubble/boom-analytics';
import withBrowserInfo from '../../containers/redux/withBrowserInfo';
import withGlobalNavigation from '../../containers/apollo/withGlobalNavigation';

const WrappedProductNav = props => {
  const { browser, globalNavigation } = props;
  if (!browser.is.large) {
    return null;
  }

  return <ProductNav {...props} items={globalNavigation} />;
};
const ComposedAndWrappedProductNav = compose(
  injectIntl,
  withBrowserInfo,
  withAnalytics,
  withGlobalNavigation
)(WrappedProductNav);

ComposedAndWrappedProductNav.displayName = ProductNav.displayName;

export default ComposedAndWrappedProductNav;
